import { useEffect, useRef, type ReactNode } from "react";

import { useAppDispatch } from "@/app/hooks";
import { bootstrapAuthSession } from "@/features/auth/authSessionThunks";

export function SessionBootstrap({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) {
      return;
    }
    startedRef.current = true;
    void dispatch(bootstrapAuthSession(undefined));
  }, [dispatch]);

  return children;
}
